export default __webpack_public_path__ + "static/media/job4.ac155c66.svg";